import React, { useState, useRef, useEffect } from "react";
import "./Profile.css";
import { FaCamera } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import SendReport from "../SendReport/SendReport";
import useMainProfile from "../../Hooks/useMainProfile";
import { useAuth } from "../../AuthContext";
import { useNavigate } from "react-router-dom";

export default function Profile({
  usedIn,
  savedProfile,
  onProfileChange,
  onShowAlert,
}) {
  const navigate = useNavigate();
  const { userToken } = useAuth();
  const { userMainData } = useMainProfile(userToken);
  const fileInputRef = useRef(null);
  const [profileImg, setProfileImg] = useState(null);
  const [userPhoneNumber, setUserPhoneNumber] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState(null);

  useEffect(() => {
    if (userMainData.profile_pic) {
      setProfileImg(userMainData.profile_pic);
    }
  }, [userMainData]);

  useEffect(() => {
    const storedPhoneNumber = localStorage.getItem("userPhoneNumber");
    if (storedPhoneNumber) {
      setUserPhoneNumber(storedPhoneNumber);
    }
  }, []);

  const handleProfileClick = (e) => {
    e.stopPropagation();
    if (usedIn !== "editProfile") {
      navigate("/editProfile");
    }
    fileInputRef.current.click();
  };

  const formatBase64 = (path, base64) => {
    if (path.endsWith(".pdf") || path.endsWith(".PDF")) {
      return `data:application/pdf;base64,${base64}`;
    } else if (path.endsWith(".png") || path.endsWith(".PNG")) {
      return `data:image/png;base64,${base64}`;
    } else if (path.endsWith(".jpg") || path.endsWith(".JPG")) {
      return `data:image/jpg;base64,${base64}`;
    } else if (path.endsWith(".jpeg") || path.endsWith(".JPEG")) {
      return `data:image/jpeg;base64,${base64}`;
    } else if (path.endsWith(".mp3") || path.endsWith(".MP3")) {
      return `data:audio/mpeg;base64,${base64}`;
    }
    return base64;
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const imageUrl = URL.createObjectURL(selectedFile);
      setProfileImg(imageUrl);
      const base64Image = await blobToBase64(imageUrl);
      const formattedBase64 = formatBase64(selectedFile.name, base64Image);
      onProfileChange(formattedBase64);
    }
  };

  useEffect(() => {
    if (savedProfile) {
      setProfileImg(savedProfile);
    }
  }, [savedProfile]);

  const blobToBase64 = (blobUrl) => {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result.split(",")[1]);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", blobUrl);
      xhr.responseType = "blob";
      xhr.send();
    });
  };

  const handleReportAlert = () => {
    onShowAlert();
  };

  useEffect(() => {
    if (profileImg) {
      const img = new Image();
      img.src = profileImg;
      img.onload = () => {
        setBackgroundImage(`url(${profileImg})`);
      };
      img.onerror = () => {
        setImageError(true);
      };
    }
  }, [profileImg]);

  return (
    <div className="profile horizontalBorder centeredFlex responsiveWidth">
      <div className="profileRight centeredFlex">
        <div className="profilePhoto centeredFlex" onClick={handleProfileClick}>
          {usedIn === "editProfile" && (
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
              accept="image/*"
            />
          )}
          <div
            className="profilePhotoInner centeredFlex"
            style={
              profileImg && !imageError
                ? { backgroundImage: backgroundImage }
                : { backgroundImage: "none" }
            }
          >
            {!profileImg && <FaCamera />}
            {imageError && <FaCamera />}
          </div>
          {usedIn === "editProfile" && (
            <div className="addPhoto centeredFlex">
              <FaPlus className="plusIcon" />
            </div>
          )}
        </div>
        <div className="userProfileData">
          <h2 className="profileUsername">{userMainData.latin_name}</h2>
          <div className="profileAgePhoneWrapper">
            <div className="centeredFlex">
              {userMainData.age ? userMainData.age : 0}
            </div>
            {usedIn === "editProfile" && userPhoneNumber && (
              <span className="centeredFlex">{userPhoneNumber}</span>
            )}
          </div>
        </div>
      </div>
      {usedIn === "userPanel" && (
        <div className="profileSendReport">
          <SendReport from="userPanel" onShowAlert={handleReportAlert} />
        </div>
      )}
    </div>
  );
}
